import HomePayments from './HomePayments';

export default HomePayments;
